import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import * as authActions from './auth.actions';
import { KrosUser } from '../services/auth/kros-user.model';

@Injectable()
export class AuthDispatchersService {
  readonly #store = inject(Store);

  /**
   * Starting authentication process
   */
  public startAuthentication(): void {
    this.#store.dispatch(authActions.startAuthentication());
  }

  /**
   * Logout currently logged user
   */
  public logoutUser(): void {
    this.#store.dispatch(authActions.logoutUser());
  }

  /**
   * Setting current user
   */
  public setUser(user: KrosUser): void {
    this.#store.dispatch(authActions.setUser({ user }));
  }

  /**
   * Resetting current user to null
   */
  public setEmptyUser(): void {
    this.#store.dispatch(authActions.setEmptyUser());
  }
}
